// extracted by mini-css-extract-plugin
export default {"base":"HighlightTag_base__s8sEd"};